import PropTypes from 'prop-types'

// Internal components
import Button from '../Button/Button'
import SponsorBlock from '../SponsorBlock/SponsorBlock'
import LazyImage from '../LazyImage/LazyImage'

const BannerBlock = (props) => {
  const {
    bannerBlockTitle,
    bannerBlockText,
    bannerBlockImage,
    optionalButton,
    modifiers,
    bannerBlockImageList,
    bannerBlockSponsors
  } = props
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  const bannerBlockTextHtml = typeof bannerBlockText === 'string' ? bannerBlockText : bannerBlockText?.html
  const createMarkup = (text) => ({ __html: text })

  return (
    <div className={`BannerBlock${modifierClasses}`}>
      <div className="BannerBlock-container">
        {((bannerBlockImage && bannerBlockImage.length > 0) ||
          (bannerBlockImageList && bannerBlockImageList.length > 0)) && (
          <div className="BannerBlock-figureWrap">
            {bannerBlockSponsors.length > 0 ? (
              bannerBlockImageList[0].heading &&
              bannerBlockImageList[0].images.length > 0 && <SponsorBlock {...bannerBlockImageList[0]} />
            ) : (
              <div className="BannerBlock-figure">
                <LazyImage image={bannerBlockImage[0]?.image ?? null} modifiers={['LazyImage--bannerBlock']} />
              </div>
            )}
          </div>
        )}
        <div
          className={`BannerBlock-textWrap${
            bannerBlockSponsors.length > 0 ? ' BannerBlock-textWrap--sponsorBlock' : ''
          }`}
        >
          <div className="BannerBlock-text">
            <h3 className="BannerBlock-title">{bannerBlockTitle && bannerBlockTitle}</h3>
            <div
              className="BannerBlock-description"
              dangerouslySetInnerHTML={createMarkup(bannerBlockTextHtml)}
            ></div>
            {optionalButton && (
              <div className="BannerBlock-buttonContainer">
                {optionalButton.map(({ button }, index) => (
                  <Button
                    href={button.url}
                    target={button.target}
                    label={button.customText || button.text}
                    icon={{ id: 'icon-chevron-right' }}
                    modifiers={['Button--bannerBlock']}
                    key={`Bannerblock-button--${index}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

BannerBlock.propTypes = {
  bannerBlockTitle: PropTypes.string,
  bannerBlockText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bannerBlockImage: PropTypes.array.isRequired,
  optionalButton: PropTypes.array,
  modifiers: PropTypes.array,
  bannerBlockImageList: PropTypes.array,
  bannerBlockSponsors: PropTypes.array
}

export default BannerBlock
